module.exports = __webpack_public_path__ + "static/media/03.6d14531d.svg";